import { environment } from '@app/environments/environment';

const APP_PROMOTION_BASE_PATH = 'promo/app_promotion';

const withBase = (file: string) =>
    `${environment.CEPH_URL}/${APP_PROMOTION_BASE_PATH}/${file}.webp`;

export const APP_PROMOTION_ASSETS = {
    appShowcaseDesktop: withBase('app-showcase-desktop'),
    appShowcaseMobile: withBase('app-showcase-mobile'),
    qrCode: withBase('app-qr-code'),
    appStore: withBase('app-store-btn'),
    appStoreMobile: withBase('app-store-btn-mobile'),
    googlePlay: withBase('google-play-btn'),
    googlePlayMobile: withBase('google-play-btn-mobile'),
} as const;

export const APP_PROMOTION_LINKS = {
    appStoreUrl: 'https://apps.apple.com/pl/app/nocowanie-pl/id6745260402?l=pl',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=pl.nocowanie.app&hl=pl',
} as const;

export const APP_PROMOTION_SIZES = {
    showcase: {
        mobile: {
            width: 629,
            height: 320,
        },
        desktop: {
            width: 667,
            height: 691,
        },
    },
    buttons: {
        googlePlay: {
            desktop: {
                htmlWidth: 135,
                htmlHeight: 40,
            },
            mobile: {
                htmlWidth: 149,
                htmlHeight: 44,
            },
        },
        appStore: {
            desktop: {
                htmlWidth: 135,
                htmlHeight: 40,
            },
            mobile: {
                htmlWidth: 148,
                htmlHeight: 44,
            },
        },
    },
} as const;
